import { TranslationKeys } from './types';

export const en: TranslationKeys = {
  // Home
  'home.beautyProfiler': 'Beauty Profiler',
  'home.looksGallery': 'Galerie des Looks',
  'home.fragranceProfiler': 'Fragrance Profiler',

  // Landing pages
  'landing.beautyProfiler.subtitle': 'Unveal Your Iconic',
  'landing.beautyProfiler.title': 'allure',
  'landing.beautyProfiler.description': 'Beauty Profiler',
  'landing.fragranceProfiler.subtitle': 'Find Your',
  'landing.fragranceProfiler.title': 'Fragrance',
  'landing.fragranceProfiler.description': 'Step into your allure of confidence',
  'landing.start': 'Start',

  // Loading
  'loading.text': 'Loading',

  // Common actions
  'back': 'Back',
  'continue': 'Continue',
  'discover': 'Discover',
  'viewLook': 'View look',
  'playVideo': 'Play video',
  'watchTutorial': 'Watch tutorial',
  'scrollProductsRight': 'Scroll products right',

  // Profiler
  'profiler.beautySubtitle': 'Your Christian Louboutin Allure',

  // Beauty profiler results
  'results.beauty.stepInto': 'Step into',
  'results.beauty.the': 'The',
  'results.beauty.allureALaLouboutin': 'allure à la louboutin',
  'results.beauty.favoriteFragrance': 'Your Favorite Fragrance',
  'results.beauty.moreScents': 'More scents to express your allure...',
  'results.beauty.personalizedRitual': 'Your personalized Christian Louboutin',
  'results.beauty.beautyRitual': 'Beauty Ritual',
  'results.beauty.with': 'with...',
  'results.beauty.lipsSignature': 'Your allure, your lips signature',

  // Fragrance profiler results
  'results.fragrance.favoriteFragranceIs': 'Your favorite fragrance is',
  'results.fragrance.createYourOwnStyle': 'Create your own style, twist',
  'results.fragrance.addTouchOf': 'and add a touch of',
  'results.fragrance.opulence': 'Opulence',
  'results.fragrance.sensuality': 'Sensuality',
  'results.fragrance.mystery': 'Mystery',
  'results.fragrance.elegance': 'Elegance',
  'results.fragrance.youShouldAlsoLike': 'You should also like...',

  // Looks gallery
  'looksGallery.beautyServices': 'Beauty services',
  'looksGallery.yourGlamorousJourney': 'Your glamorous journey',
  'looksGallery.galerieDesLooks': 'La galerie des looks',
  'looksGallery.revealYourBeauty': 'Reveal your beauty with sophistication',
  'looksGallery.looksALaLouboutin': 'Looks à la Louboutin',
  'looksGallery.christianLouboutin': 'Christian Louboutin',

  // Beauty services
  'beautyServices.christianLouboutin': 'Christian Louboutin',
  'beautyServices.title': 'Beauty services',
  'beautyServices.makeup': 'Makeup',
  'beautyServices.fragrance': 'Fragrance',
  'beautyServices.min': 'min',

  // Error
  'error.somethingWentWrong': 'Something went wrong',
  'error.pleaseRefresh': 'Please refresh the page to try again.',
};
